import React from "react";
import { Box, Flex, Stack, Text, Button, Grid } from "@chakra-ui/core";
import styles from "./styles.module.css";

import { EventCard, OyeJobCard } from "../../components/Card";
import { Layout } from "../../layouts/Layout";
import { oyeGraduates } from "../../lib/utils/mock";
import { useWindowDimensions } from "../../lib/utils/hooks";
import Hero from "../../components/Hero";
import CustomBreadcrumb from "../../layouts/Breadcrumb";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router";

const OyeGraduates = () => {
  const { width } = useWindowDimensions();

  const history = useHistory();

  const isMobile = width <= 700;
  return (
    <Layout title='Oye Graduates | GrEEn'>
      <CustomBreadcrumb
        links={[
          { title: "Green Employment", link: "/oye-graduates" },
          {
            title: "OYE Graduates",
            link: "/oye-graduates",
          },
        ]}
      />
      <Box position='relative'>
        <Hero
          // heroHeading='OYE GRADUATES'
          // heroSub='OYE GRADUATES'
          headerHeight='40%'
          heroImage={require("../../assets/images/hero-8.jpg")}
        />
      </Box>

      <Box px={["20px", "80px"]} py={["0", "0"]} className={styles.Center}>
        <Flex
          justify='space-between'
          align='center'
          py={["10", "10"]}
          px={["5px", "30px"]}
        >
          <Text
            fontSize={["24px", "35px"]}
            fontWeight='800'
            fontFamily='Familiar Pro'
          >
            OYE Graduates
          </Text>
          {/* <Button>Apply for OYE</Button> */}
          <Button
            bg='green.400'
            color='#fff'
            className='hvr-bounce-in'
            _hover={{ bg: "green.500", color: "#fff" }}
            onClick={() => history.push("/dashboard/application/oye-details")}
          >
            Apply for OYE
          </Button>
        </Flex>

        <Box px={["0px", "30px"]}>
          {/* <Flex wrap='wrap' justify='space-between'> */}
          <Grid
            templateColumns={[
              "repeat(auto-fit, minmax(250px, 1fr))",
              "repeat(auto-fit, minmax(250px, 250px))",
            ]}
            justifyContent='space-between'
            gap='6'
          >
            {oyeGraduates.map((oye) => {
              return (
                <Box mb='4'>
                  <EventCard
                    heading={oye.title}
                    imageSrc={oye.icon}
                    width={["100%", "250px"]}
                    marginRight={["0", "15px"]}
                  >
                    <Stack>
                      <Text>{oye.position}</Text>
                      <Text>{oye.companyName}</Text>
                    </Stack>
                  </EventCard>
                </Box>
              );
            })}
          </Grid>
          {/* </Flex> */}
          <Box mb='10' d='flex' justifyContent='center'>
            <Button variant='link' variantColor='green'>
              Load More
            </Button>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default OyeGraduates;
